import React, { useEffect } from 'react';
import Contact from '../components/Contact';

import web_development_banner from '../assets/web_development_banner.jpg'
import web_development from '../assets/website_development.png'

const WebsiteDevelopment = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className='mt-20 relative'>
        <div className='relative mt-[6rem]'>
          <img
            className='w-full h-[40rem] blur-sm object-cover'
            src={web_development_banner}
            alt='Website Development at Jyotinay Analytics'
          />
          <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
            <p className='text-white text-3xl md:text-5xl font-bold'>
              Website Development at Jyotinay Analytics
            </p>
            <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              Build fast, beautiful, and scalable websites that convert visitors into customers — with Jyotinay’s expert development team.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='container mx-auto mt-12 px-4'>
        <div className='max-w-3xl mx-auto text-left'>
          <p className='text-base md:text-lg leading-relaxed'>
            In the digital world, your website is often the first impression your business makes.
            At Jyotinay Analytics, we design and develop responsive, user-friendly, and high-performing websites
            tailored to your unique brand and business goals.
          </p>

          <img
            className='w-full md:w-[30rem] h-[15rem] object-cover mt-8 rounded-lg shadow-md mx-auto'
            src={web_development}
            alt='Website Development Team at Work'
          />

          {/* Why Website Development Section */}
          <div className='mt-12'>
            <h2 className='text-xl md:text-2xl font-semibold mb-4'>
              Why Choose Jyotinay for Website Development?
            </h2>

            <p className='mb-4 text-base md:text-lg leading-relaxed'>
              Our development team combines creativity, performance, and functionality to build websites
              that not only look stunning but also deliver results. From e-commerce to corporate sites,
              we’ve got your digital presence covered.
            </p>

            <p className='mb-6 text-base md:text-lg leading-relaxed'>
              Whether you're building from scratch or modernizing an outdated site,
              our approach is collaborative, scalable, and results-driven.
            </p>

            <ul className='list-disc ml-6 space-y-2 text-base md:text-lg'>
              <li>Custom website design and development</li>
              <li>Responsive, mobile-first layouts</li>
              <li>SEO optimization and performance tuning</li>
              <li>CMS integration (WordPress, Headless CMS, etc.)</li>
              <li>Secure, scalable, and fast-loading websites</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Contact Form */}
      <Contact />
    </div>
  );
};

export default WebsiteDevelopment;
